import React, { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from '../../Layout';
import { ErrorBoundary } from '../../../shared/components/ErrorBoundary';
import { SettingsRoutes } from '../../shared/routes';
import { useSelector } from 'react-redux';
import { IAllStates } from '../../../store/rootReducer';
import StripeSuccessfulPage from '../../../shared/components/stripe/StripeSuccessfulPage';
import StripeFailedPage from '../../../shared/components/stripe/StripeFailedPage';

const GlobalDiscovery = lazy(() => import('./index'));
const GlobalDiscoveryListsPage = lazy(() => import('./favorite-lists'));
const GlobalDiscoveryListDetailPage = lazy(() => import('./favorite-lists/favorite-list-detail'));
const PackageOverview = lazy(() => import('../../shared/packages').then(m => ({ default: m.PackageOverview })));
const ForbiddenPage = lazy(() => import('../../../authentication/403'));

export function GlobalDiscoveryRoutes() {
    const isPackageShownToUser = useSelector(
        (states: IAllStates) => states?.auth?.user?.company?.package?.isShownToUser
    );
    const isDiscoveryLimited = useSelector(
        (states: IAllStates) => states?.auth?.user?.company?.package?.limitDiscovery
    );

    return (
        <Suspense fallback>
            <ErrorBoundary>
                <Routes>
                    <Route element={<Layout />}>
                        <Route path="/brand/discovery/" element={<GlobalDiscovery />} />
                        <Route
                            path="/brand/discovery/lists"
                            element={
                                !isDiscoveryLimited ? (
                                    <GlobalDiscoveryListsPage />
                                ) : (
                                    <Navigate to="/brand/discovery" replace />
                                )
                            }
                        />
                        <Route
                            path="/brand/discovery/lists/detail/:id"
                            element={
                                !isDiscoveryLimited ? (
                                    <GlobalDiscoveryListDetailPage />
                                ) : (
                                    <Navigate to="/brand/discovery" replace />
                                )
                            }
                        />
                        <Route path="/brand/discovery/payment-successful" element={<StripeSuccessfulPage />} />
                        <Route path="/brand/discovery/payment-failed" element={<StripeFailedPage />} />
                        <Route path="/settings/*" element={<SettingsRoutes />} />
                        {isPackageShownToUser && <Route path="/brand/package-overview" element={<PackageOverview />} />}
                        <Route path="/403" element={<ForbiddenPage />} />
                    </Route>
                    <Route path="/auth/login" element={<Navigate to="/brand/discovery" replace />} />
                    <Route path="/" element={<Navigate to="/brand/discovery" replace />} />
                    <Route path="*" element={<Navigate to="/brand/discovery" replace />} />
                </Routes>
            </ErrorBoundary>
        </Suspense>
    );
}
